var _path, _path2, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcAvatar = function SvgIcAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20Z",
    fill: "#F2F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 13.133a2.652 2.652 0 0 1 2.644 2.645 2.652 2.652 0 0 1-2.644 2.644 2.652 2.652 0 0 1-2.644-2.644 2.652 2.652 0 0 1 2.644-2.645Zm0-1.133a3.789 3.789 0 0 0-3.778 3.778c0 2.078 1.7 3.778 3.778 3.778 2.078 0 3.778-1.7 3.778-3.778 0-2.078-1.7-3.778-3.778-3.778Zm2.267 9.444c1.87 0 3.4 1.53 3.4 3.4v1.89c0 .623-.51 1.133-1.134 1.133h-9.066c-.624 0-1.134-.51-1.134-1.134v-1.889c0-1.87 1.53-3.4 3.4-3.4h4.534Zm0-1.133h-4.534A4.547 4.547 0 0 0 13 24.844v1.89A2.273 2.273 0 0 0 15.267 29h9.066a2.273 2.273 0 0 0 2.267-2.267v-1.889a4.547 4.547 0 0 0-4.533-4.533Z",
    fill: "#99A6AB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#ic_avatar_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "ic_avatar_svg__a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ic_avatar_svg__b"
  })), /*#__PURE__*/React.createElement("image", {
    id: "ic_avatar_svg__b",
    width: 1,
    height: 1,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAQSURBVHgBAQUA+v8AAAAAAAAFAAFkeJU4AAAAAElFTkSuQmCC"
  }))));
};
export default SvgIcAvatar;